module.exports = __webpack_public_path__ + "static/media/sample_3-08.0e64118f.jpg";